<template>
  <div class="ideco-criminal-component">
    <div
      class="service-header mb-2 d-flex align-items-center justify-content-between"
    >
      <div>
        <h6 class="fs-6 fw-semibold text-dark mb-1 mt-0">
          IDECO Criminal Check
        </h6>
        <p class="text-xs text-muted mb-0 lh-sm">
          Comprehensive criminal background verification including address and
          fingerprint details.
        </p>
      </div>
    </div>

    <div class="row g-2">
      <!-- Required fields first -->
      <div class="col-md-6">
        <label class="form-label text-xs fw-medium text-secondary"
          >Gender <span class="text-danger">*</span></label
        >
        <select
          class="form-select form-select-sm text-xs"
          v-model="ideco_data.gender_code"
          id="gender-field"
        >
          <option value="">Select gender</option>
          <option value="1">Male</option>
          <option value="2">Female</option>
        </select>
      </div>
      <div class="col-md-6">
        <label class="form-label text-xs fw-medium text-secondary"
          >Race <span class="text-danger">*</span></label
        >
        <select
          class="form-select form-select-sm text-xs"
          v-model="ideco_data.population_group_code"
          id="race-field"
        >
          <option value="">Select race</option>
          <option value="1">Black</option>
          <option value="2">White</option>
          <option value="3">Coloured</option>
          <option value="4">Asian</option>
          <option value="5">Other</option>
          <option value="6">Black and Coloured</option>
        </select>
      </div>
      <!-- Optional fields next -->
      <div class="col-md-6">
        <label class="form-label text-xs fw-medium text-secondary"
          >Country of Birth (Optional)</label
        >
        <input
          type="text"
          class="form-control form-control-sm text-xs"
          placeholder="Enter country of birth"
          v-model="ideco_data.country_of_birth"
        />
      </div>
      <div class="col-md-6">
        <label class="form-label text-xs fw-medium text-secondary"
          >Address 1 (Optional)</label
        >
        <input
          type="text"
          class="form-control form-control-sm text-xs"
          placeholder="Enter address line 1"
          v-model="ideco_data.address1"
        />
      </div>
      <div class="col-md-6">
        <label class="form-label text-xs fw-medium text-secondary"
          >Address 2 (Optional)</label
        >
        <input
          type="text"
          class="form-control form-control-sm text-xs"
          placeholder="Enter address line 2"
          v-model="ideco_data.address2"
        />
      </div>
      <div class="col-md-6">
        <label class="form-label text-xs fw-medium text-secondary"
          >Fingerprints Taken At (Optional)</label
        >
        <input
          type="text"
          class="form-control form-control-sm text-xs"
          placeholder="Enter location"
          v-model="ideco_data.fingerprints_taken_at"
        />
      </div>
      <div class="col-md-6">
        <label class="form-label text-xs fw-medium text-secondary"
          >Previous Charges 1 (Optional)</label
        >
        <input
          type="text"
          class="form-control form-control-sm text-xs"
          placeholder="Enter previous charges"
          v-model="ideco_data.previous_charges1"
        />
      </div>
      <div class="col-md-6">
        <label class="form-label text-xs fw-medium text-secondary"
          >Previous Charges 2 (Optional)</label
        >
        <input
          type="text"
          class="form-control form-control-sm text-xs"
          placeholder="Enter additional charges"
          v-model="ideco_data.previous_charges2"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { API_BASE_URL } from "@/config";
export default {
  name: "IdecoCriminal",
  props: {
    service_id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      ideco_data: {
        id: "",
        gender_code: "",
        population_group_code: "",
        country_of_birth: "",
        address1: "",
        address2: "",
        fingerprints_taken_at: "",
        previous_charges1: "",
        previous_charges2: "",
      },
    };
  },
  methods: {
    set_field_invalid(field_id) {
      const el = document.getElementById(field_id);
      if (el) el.classList.add("border-danger");
    },
    set_field_valid(field_id) {
      const el = document.getElementById(field_id);
      if (el) el.classList.remove("border-danger");
    },
    handle_data_submit() {
      // Validate required fields
      this.set_field_valid("gender-field");
      this.set_field_valid("race-field");

      if (this.ideco_data.gender_code === "") {
        this.set_field_invalid("gender-field");
        Swal.fire({
          icon: "info",
          title: "Validation Error",
          text: "Please select gender.",
          timer: 2500,
          timerProgressBar: true,
          showConfirmButton: false,
        });

        return false;
      }
      if (this.ideco_data.population_group_code === "") {
        this.set_field_invalid("race-field");
        Swal.fire({
          icon: "info",
          title: "Validation Error",
          text: "Please select race.",
          timer: 2500,
          timerProgressBar: true,
          showConfirmButton: false,
        });
        return false;
      }

      this.$emit("update_data", "ideco", this.ideco_data);
      return true;
    },
    fetch_data() {
      const token = localStorage.getItem("token");
      const workflow_id = localStorage.getItem("workflow_id") || null;
      if (!workflow_id) {
        console.error("Workflow ID is not set in localStorage.");
        return;
      }

      const params = new URLSearchParams({
        workflow_id: workflow_id,
        service_id: this.service_id
      });

      fetch(
        `${API_BASE_URL}/verify_api/employee_screening/api/get_sections_by_workflow_client/?${params.toString()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === "success" && data.data && data.data.sections && data.data.sections.length > 0) {
            // Find the section for IDECO Criminal Check (or use the first section)
            const section = data.data.sections.find(
              s => s.service_name === "IDECO Criminal Check"
            ) || data.data.sections[0];

            // Flatten key_mappings into an object
            let criminal = {};
            let key_group = {};
            if (
              section &&
              section.key_groups &&
              section.key_groups.length > 0 &&
              section.key_groups[0].key_mappings
            ) {
              key_group = section.key_groups[0];
              section.key_groups[0].key_mappings.forEach(mapping => {
                criminal[mapping.key_name] = mapping.key_value;
              });
            }
            // Set data
            this.ideco_data.id = key_group.id || "";
            this.ideco_data.gender_code = criminal.gender_code || "";
            this.ideco_data.population_group_code = criminal.population_group_code || "";
            this.ideco_data.country_of_birth = criminal.country_of_birth || "";
            this.ideco_data.address1 = criminal.address1 || "";
            this.ideco_data.address2 = criminal.address2 || "";
            this.ideco_data.fingerprints_taken_at = criminal.fingerprints_taken_at || "";
            this.ideco_data.previous_charges1 = criminal.previous_charges1 || "";
            this.ideco_data.previous_charges2 = criminal.previous_charges2 || "";
          } else {
            // Reset fields if no data
            this.ideco_data = {
              id: "",
              gender_code: "",
              population_group_code: "",
              country_of_birth: "",
              address1: "",
              address2: "",
              fingerprints_taken_at: "",
              previous_charges1: "",
              previous_charges2: "",
            };
          }
        })
        .catch((error) => {
          console.error("Error fetching criminal data:", error);
        });
    },
  },
  mounted() {
    this.fetch_data();
  },
};
</script>

<style scoped>
.service-header {
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f1f3f4;
}

.form-label {
  margin-bottom: 0.25rem;
}

.form-control-sm {
  padding: 0.375rem 0.5rem;
}
</style>
